<template>
  <div>
    <Header />
    <AppServices />
    <AppCcf />
    <AppAvantages />
    <AppContact />
  </div>
</template>

<script>
import Header from "@/components/landing-page/AppLandingHeader";
import AppServices from "@/components/landing-page/AppServices";
import AppCcf from "@/components/landing-page/AppCcf";
import AppAvantages from "@/components/landing-page/AppAvantages";
import AppContact from "@/components/landing-page/AppContact";
import { mapGetters } from "vuex";
export default {
  components: {
    Header,
    AppServices,
    AppCcf,
    AppAvantages,
    AppContact
  },
  computed: {
    ...mapGetters({
      user: "user",
      loading: "loading",
      firstLoginDialog: "firstLoginDialog"
    }),
  },
  methods: {

  }
};
</script>

<style scoped>
@import url("./../assets/css/main-css.css");
</style>